import { render } from "./exquisite-handwork-hero.vue?vue&type=template&id=77590b77&scoped=true"
import script from "./exquisite-handwork-hero.vue?vue&type=script&lang=js"
export * from "./exquisite-handwork-hero.vue?vue&type=script&lang=js"

import "./exquisite-handwork-hero.vue?vue&type=style&index=0&id=77590b77&lang=css"
import "./exquisite-handwork-hero.vue?vue&type=style&index=1&id=77590b77&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77590b77"]])

export default __exports__